import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthProvider';
import useToken from '../../hooks/useToken';




const Login = () => {
    
    const { loginUser } = useContext(AuthContext)
    const { register, formState: { errors }, handleSubmit } = useForm();
    const [loginError, setLoginError] = useState('');
    const [data, setData] = useState();
    const [loginUserEmail, setLoginUserEmail] = useState('');
    const [token] = useToken(loginUserEmail)

    


    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.form?.pathname || '/';


    if(token){
        navigate(from, { replace: true })

    }

    const handleLogin = data => {
        console.log(data)
        loginUser(data.email, data.password)
            .then(result => {
                const user = result.user;
                setLoginUserEmail(data.email)
                navigate(from, { replace: true })

                console.log(user)
            })
            .catch(error => {
                console.log(error.message)
                setLoginError(error.message)
            })
    };

    return (
        <div>

            <div className="mx-auto text-center justify-center my-10 lg:w-1/3 shadow-lg p-10 rounded-lg">
                <div className="">
                    <h1 className='font-bold text-3xl'>Login!</h1>
                </div>
                <form onSubmit={handleSubmit(handleLogin)}>

                    <div className="form-control w-full ">
                        <label className="label">
                            <span className="label-text">Email</span>
                        </label>
                        <input {...register("email",
                            { required: true }
                        )

                        } type="email" placeholder="Type here" className="input input-bordered w-full  " />
                        {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                    </div>
                    <div className="form-control w-full ">
                        <label className="label">
                            <span className="label-text">Password</span>
                        </label>
                        <input {...register("password",
                            {
                                required: "Password is Required",
                                minLength: { value: 6, message: "Password Must be 6 character or longer" }
                            })}
                            aria-invalid={errors.password ? "true" : "false"}
                            type="password" placeholder="password" className="input input-bordered w-full " />
                        {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                    </div>
                    {
                        loginError && <p className='text-red-600'>{loginError}</p>
                    }
                    <button className="btn btn-info w-full my-5">Login</button>

                    <div className="flex flex-col w-full border-opacity-50">

                        <div className="divider">OR</div>

                    </div>
                    <Link to='/register'><button className="btn btn-outline w-full my-5">SignUp</button></Link>

                </form>
            </div>

        </div>
    );
};

export default Login;